import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full overflow-hidden" }
const _hoisted_2 = { class: "flex items-center gap-1" }
const _hoisted_3 = { class: "text-xs font-bold" }
const _hoisted_4 = ["href"]

import { useI18n } from 'vue-i18n';
    import Corpay from '../icons/Corpay.vue';
    import KeepersSmall from '../icons/KeepersSmall.vue';
    import Marquee from '../Marquee.vue';
    import { computed } from 'vue';
    import type { Company } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboardMarquee',
  props: {
    company: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const items = computed(() => {
        const list = [];

        if (props.company.keepers_email) {
            list.push({
                icon: KeepersSmall,
                title: t('companies.form.keepers_email'),
                email: props.company.keepers_email,
            });
        }

        if (props.company.roger_invoices) {
            list.push({
                icon: Corpay,
                title: t('companies.form.roger_invoices'),
                email: props.company.roger_invoices,
            });
        }

        if (props.company.roger_receipts) {
            list.push({
                icon: Corpay,
                title: t('companies.form.roger_receipts'),
                email: props.company.roger_receipts,
            });
        }

        return list;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Marquee, {
      gradient: true,
      "gradient-color": [255, 255, 255],
      "gradient-length": "5%",
      "pause-on-hover": "",
      clone: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.title,
            class: "flex flex-col gap-1 px-5"
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { className: "size-4" })),
              _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("a", {
              href: `mailto:${item.email}`,
              class: "text-secondary text-xs hover:underline"
            }, _toDisplayString(item.email), 9, _hoisted_4)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})